import { OrganizationRole } from "@organization/models/OrganizationRole";

// TBD rename name, because it conflicts with two other User entities
export class User {
  constructor(
    id: string,
    name: string,
    roleName: string,
    language: string,
    email: string
  ) {
    this.id = id;
    this.name = name;
    this.roleName = roleName as OrganizationRole;
    this.language = language;
    this.email = email;
  }

  readonly id: string;
  readonly name: string;
  readonly roleName: OrganizationRole;
  readonly language: string;
  readonly email: string;

  get isAdministrator(): boolean {
    return this.roleName === OrganizationRole.Admin;
  }

  get isOrgUser(): boolean {
    return this.roleName === OrganizationRole.User;
  }
}
